export enum ExportTypeEnum {
    EXPORT_ORDER_DETAILS_TO_EXCEL = "ExportOrderDetailsToExcel",
    EXPORT_ORDER_ITEM_TO_EXCEL = "ExportItemDetailsToExcel",
}
